/* =============================================================
   Phoenix TCG â€” Site shell scripts (nav, footer, cart, reveal)
   ============================================================= */

(function () {
  'use strict';

  // ---------- Theme (dark / light) â€” apply ASAP to minimize flash ----------
  const THEME_KEY = 'phoenix.theme.v1';
  (function applyStoredTheme() {
    // Honour a hard lock (e.g. the coming-soon gate stays dark for now) â€” if
    // <html data-theme-lock="..."> is present, leave the markup theme as-is.
    if (document.documentElement.getAttribute('data-theme-lock')) return;
    // Always write data-theme explicitly (default DARK going forward) so
    // selectors and the brand-mark dual-img swap have a stable attribute on
    // first visit too. Users can switch to light; the choice persists.
    let theme = 'dark';
    try {
      const stored = localStorage.getItem(THEME_KEY);
      if (stored === 'light' || stored === 'dark') theme = stored;
    } catch (e) {}
    document.documentElement.setAttribute('data-theme', theme);
  })();
  function toggleTheme() {
    const current = document.documentElement.getAttribute('data-theme') || 'dark';
    const next = current === 'dark' ? 'light' : 'dark';
    document.documentElement.setAttribute('data-theme', next);
    try { localStorage.setItem(THEME_KEY, next); } catch (e) {}
  }
  window.PhoenixTheme = { toggle: toggleTheme };

  // ---------- Cart store (localStorage) ----------
  const KEY = 'phoenix.cart.v1';
  function readCart() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function writeCart(items) {
    localStorage.setItem(KEY, JSON.stringify(items));
    updateCartCount();
  }
  function cartCount() {
    return readCart().reduce((n, it) => n + (it.qty || 1), 0);
  }
  function cartTotal() {
    return readCart().reduce((n, it) => n + (it.price * (it.qty || 1)), 0);
  }
  function addToCart(item) {
    const items = readCart();
    const existing = items.find(i => i.id === item.id);
    if (existing) existing.qty = (existing.qty || 1) + (item.qty || 1);
    else items.push(Object.assign({ qty: 1 }, item));
    writeCart(items);
  }
  function setQty(id, qty) {
    const items = readCart().map(i => i.id === id ? Object.assign({}, i, { qty }) : i).filter(i => i.qty > 0);
    writeCart(items);
  }
  function removeFromCart(id) {
    writeCart(readCart().filter(i => i.id !== id));
  }
  function clearCart() { writeCart([]); }

  function updateCartCount() {
    document.querySelectorAll('[data-cart-count]').forEach(el => {
      const n = cartCount();
      el.textContent = n;
      el.style.display = n > 0 ? '' : '';
    });
  }

  window.PhoenixCart = { read: readCart, add: addToCart, setQty, remove: removeFromCart, clear: clearCart, count: cartCount, total: cartTotal };

  // ---------- Toast ----------
  function toast(msg) {
    let wrap = document.querySelector('.toast-wrap');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'toast-wrap';
      document.body.appendChild(wrap);
    }
    const t = document.createElement('div');
    t.className = 'toast';
    t.innerHTML = `<span class="ic"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 5 5L20 7"/></svg></span><span></span>`;
    t.lastElementChild.textContent = msg;   // text only: product names / cart errors never parsed as HTML
    wrap.appendChild(t);
    setTimeout(() => { t.style.opacity = '0'; t.style.transform = 'translateY(8px)'; t.style.transition = 'opacity 200ms, transform 200ms'; }, 2200);
    setTimeout(() => t.remove(), 2500);
  }

  // ---------- Gem burst (add-to-cart delight) ----------
  const GEM_COLORS = ['#F2B84B', '#D68C26', '#B8D4E8', '#C4506A', '#E8E6E1'];
  function gemBurst(x, y) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (typeof x !== 'number' || !x) { x = innerWidth / 2; y = innerHeight / 2; }
    const layer = document.createElement('div');
    layer.style.cssText = 'position:fixed;left:0;top:0;width:0;height:0;z-index:9999;pointer-events:none';
    document.body.appendChild(layer);
    for (let i = 0; i < 16; i++) {
      const s = document.createElement('span');
      s.style.cssText = 'position:fixed;width:7px;height:7px;border-radius:50%;will-change:transform,opacity;' +
        'left:' + x + 'px;top:' + y + 'px;background:' + GEM_COLORS[i % GEM_COLORS.length];
      layer.appendChild(s);
      const ang = (Math.PI * 2 * i) / 16 + Math.random() * 0.4, dist = 42 + Math.random() * 40;
      s.animate(
        [{ transform: 'translate(-50%,-50%) scale(1)', opacity: 1 },
         { transform: 'translate(calc(-50% + ' + (Math.cos(ang) * dist) + 'px),calc(-50% + ' + (Math.sin(ang) * dist - 12) + 'px)) scale(0)', opacity: 0 }],
        { duration: 620 + Math.random() * 240, easing: 'cubic-bezier(.2,.8,.2,1)', fill: 'forwards' });
    }
    setTimeout(() => layer.remove(), 900);
  }
  window.PhoenixGemBurst = gemBurst;

  // ---------- Init ----------
  function initReveal() {
    const els = document.querySelectorAll('.reveal, .reveal-group');
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
      els.forEach(el => el.classList.add('in'));
      return;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(el => io.observe(el));
    // Safety net: if IO never fires (some embedded contexts), force-reveal after 1.5s.
    setTimeout(() => {
      document.querySelectorAll('.reveal:not(.in), .reveal-group:not(.in)').forEach(el => el.classList.add('in'));
    }, 1500);
  }

  // ---------- Image guard â€” block right-click + drag on images only ----------
  // Deterrence, not protection: stops the casual "Save Image As" / drag-to-save.
  // Scoped to <img> so normal right-click still works on text, links, etc.
  function initImageGuard() {
    document.addEventListener('contextmenu', (ev) => {
      if (ev.target.closest('img')) ev.preventDefault();
    });
    document.addEventListener('dragstart', (ev) => {
      if (ev.target.closest('img')) ev.preventDefault();
    });
  }

  // ---------- Region / currency switcher ----------
  const REGION_KEY = 'phoenix-region';
  function closeRegionMenus() {
    document.querySelectorAll('[data-region-menu]').forEach((m) => m.setAttribute('hidden', ''));
    document.querySelectorAll('[data-region-toggle]').forEach((t) => t.setAttribute('aria-expanded', 'false'));
  }
  function toggleRegionMenu(toggle) {
    const region = toggle.closest('[data-region]');
    if (!region) return;
    const menu = region.querySelector('[data-region-menu]');
    const isOpen = !menu.hasAttribute('hidden');
    closeRegionMenus();
    if (!isOpen) {
      menu.removeAttribute('hidden');
      toggle.setAttribute('aria-expanded', 'true');
    }
  }
  function applyRegion(opt) {
    const flag = opt.querySelector('.region-opt-flag');
    if (flag) {
      document.querySelectorAll('[data-region-flag]').forEach((f) => { f.innerHTML = flag.innerHTML; });
    }
    const mini = opt.getAttribute('data-mini');
    const sel = opt.getAttribute('data-select');
    document.querySelectorAll('[data-region-label-mini]').forEach((l) => { l.textContent = mini; });
    document.querySelectorAll('[data-region-label-select]').forEach((l) => { l.textContent = sel; });
  }
  function selectRegion(opt) {
    applyRegion(opt);
    try { localStorage.setItem(REGION_KEY, opt.getAttribute('data-code')); } catch (e) {}
    closeRegionMenus();
  }
  function applyStoredRegion() {
    let code;
    try { code = localStorage.getItem(REGION_KEY); } catch (e) {}
    if (!code) return;
    const opt = document.querySelector('[data-region-opt][data-code="' + code + '"]');
    if (opt) applyRegion(opt);
  }

  function initShell() {

    updateCartCount();
    initReveal();
    initImageGuard();
    applyStoredRegion();

    // Close region menus on Escape
    document.addEventListener('keydown', (ev) => {
      if (ev.key === 'Escape') closeRegionMenus();
    });

    // Wire body-level click handlers â€” region switcher + theme toggle + add-to-cart
    document.body.addEventListener('click', (ev) => {
      // Region switcher: toggle, select an option, or click-outside to close
      const regionToggle = ev.target.closest('[data-region-toggle]');
      if (regionToggle) { ev.preventDefault(); toggleRegionMenu(regionToggle); return; }
      const regionOpt = ev.target.closest('[data-region-opt]');
      if (regionOpt) { ev.preventDefault(); selectRegion(regionOpt); return; }
      if (!ev.target.closest('[data-region]')) closeRegionMenus();

      // Theme toggle
      const themeBtn = ev.target.closest('[data-theme-toggle]');
      if (themeBtn) {
        ev.preventDefault();
        toggleTheme();
        themeBtn.blur(); // drop focus so no highlight box lingers after tapping
        return;
      }
      // Gem burst on quick-add buttons. (The PDP add-to-cart burst is owned by the cart
      // drawer, which intercepts the form submit — avoid a double burst here.)
      const atc = ev.target.closest('[data-add-cart]');
      if (atc && !atc.disabled && !atc.hasAttribute('aria-disabled')) gemBurst(ev.clientX, ev.clientY);

      // Add to cart
      const btn = ev.target.closest('[data-add-cart]');
      if (!btn) return;
      ev.preventDefault();
      const data = JSON.parse(btn.getAttribute('data-add-cart'));
      addToCart(data);
      btn.classList.add('added');
      const orig = btn.textContent;
      btn.textContent = 'Added';
      setTimeout(() => { btn.classList.remove('added'); btn.textContent = orig; }, 1200);
      toast(`Added â€” ${data.name}`);
    });
  }

  window.PhoenixToast = toast;

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initShell);
  else initShell();
})();

/* GLOBAL IMAGE RULE: decide per image whether it is a packshot on white (keep the white field)
   or a photo with its own background (fill the field). Samples the outer ring of a 24px
   thumbnail: packshots score 0.77-1.0 near-white edge pixels, photos ~0, so < 0.4 = photo.
   A sample that comes back fully transparent means the image isn't painted yet: retry, never
   guess (guessing is what mis-filled packshots). Images are same-origin (/cdn/shop). */
(function(){
  var SEL = '.product .img img, .pdp-hero img#pdp-main, .bc-img img, .rc-img img, .art-hero .img-wrap img';
  // Editorial images (blog cards, article hero) default the other way round: they FILL the 16:9 frame,
  // which crops logos and packshots. Those get .img--logo instead: shown whole, centred, on their own
  // edge colour (or the frame's dark surface when the edge is transparent).
  var EDIT = '.bc-img, .rc-img, .art-hero .img-wrap';
  function whiteRatio(img){
    try {
      var c = document.createElement('canvas'), n = 24; c.width = c.height = n;
      var x = c.getContext('2d', { willReadFrequently: true }); x.drawImage(img, 0, 0, n, n);
      var d = x.getImageData(0, 0, n, n).data, white = 0, total = 0, painted = 0;
      for (var y = 0; y < n; y++) for (var i = 0; i < n; i++) {
        if (y > 1 && y < n - 2 && i > 1 && i < n - 2) continue;   // outer 2px ring only
        var k = (y * n + i) * 4; total++;
        if (d[k + 3] > 0) painted++;
        if (d[k + 3] < 20 || (d[k] > 232 && d[k + 1] > 232 && d[k + 2] > 232)) white++;   // transparent PNG edge counts as white
      }
      var all = x.getImageData(0, 0, n, n).data, any = false;
      for (var j = 3; j < all.length; j += 4) if (all[j] > 0) { any = true; break; }
      if (!any) return null;                  // null = not painted yet
      // edge colour + spread: a solid studio backdrop (black, grey, coloured) has a tiny spread
      var sr = 0, sg = 0, sb = 0, m = 0, lo = [255, 255, 255], hi = [0, 0, 0];
      for (var y2 = 0; y2 < n; y2++) for (var i2 = 0; i2 < n; i2++) {
        if (y2 > 1 && y2 < n - 2 && i2 > 1 && i2 < n - 2) continue;
        var q = (y2 * n + i2) * 4; m++; sr += d[q]; sg += d[q + 1]; sb += d[q + 2];
        for (var ch = 0; ch < 3; ch++) { lo[ch] = Math.min(lo[ch], d[q + ch]); hi[ch] = Math.max(hi[ch], d[q + ch]); }
      }
      var spread = Math.max(hi[0] - lo[0], hi[1] - lo[1], hi[2] - lo[2]);
      return { white: white / total, clear: (total - painted) / total, solid: spread < 40, rgb: 'rgb(' + Math.round(sr / m) + ',' + Math.round(sg / m) + ',' + Math.round(sb / m) + ')' };
    } catch (e) { return { white: 1 }; }     // unreadable: keep default packshot styling
  }
  function classify(img, tries){
    if (img.dataset.imgRule) return;
    var box = img.closest('.img, .pdp-hero, ' + EDIT); if (!box) return;
    if (!(img.complete && img.naturalWidth)) { img.addEventListener('load', function(){ classify(img, 0); }, { once: true }); return; }
    var r = whiteRatio(img);
    if (r === null) { if ((tries || 0) < 8) setTimeout(function(){ classify(img, (tries || 0) + 1); }, 250); return; }
    img.dataset.imgRule = '1';
    if (box.matches(EDIT)) {                                  // blog card / article hero
      if (r.white >= 0.4 || r.solid) {                        // logo, packshot or plain backdrop: never crop
        box.classList.add('img--logo');
        if (r.solid && r.white < 0.4) box.style.setProperty('--img-bg', r.rgb);   // coloured backdrop keeps its colour; logos sit on the dark card
      }
      return;                                                 // photos keep filling the frame
    }
    if (r.white >= 0.4) return;                              // packshot on white: default
    // NEVER CROP THE PRODUCT: filling the field (object-fit: cover) is only allowed when the image's
    // shape is close to the field's shape. A tall pack/box/sleeve shot whose art runs to the edge
    // otherwise loses its top and bottom (ME05 box + pack, Ultra Pro sleeves, 4 Nov 2026), so it
    // stays whole on the default white field instead.
    var bw = box.clientWidth, bh = box.clientHeight;
    if (bw && bh) {
      var ia = img.naturalWidth / img.naturalHeight, ba = bw / bh;
      if (Math.max(ia, ba) / Math.min(ia, ba) > 1.05) return;  // >5% shape mismatch (would crop >2.5% per side): show whole
    }
    if (r.solid) { box.classList.add('img--solid'); box.style.setProperty('--img-bg', r.rgb); }  // studio backdrop: show whole image on its own colour
    else box.classList.add('img--photo');                    // scene/lifestyle photo: fill edge to edge
  }
  function scan(root){ (root || document).querySelectorAll(SEL).forEach(function(i){ classify(i, 0); }); }
  function start(){
    scan();
    // grids that render later (filters, infinite scroll, recently viewed, cart upsells)
    new MutationObserver(function(ms){ ms.forEach(function(m){ m.addedNodes.forEach(function(nd){ if (nd.nodeType === 1) scan(nd); }); }); })
      .observe(document.body, { childList: true, subtree: true });
    // PDP thumbnails swap the hero src: re-check on change
    var hero = document.getElementById('pdp-main');
    if (hero) new MutationObserver(function(){ var b = hero.closest('.pdp-hero'); b && b.classList.remove('img--photo', 'img--solid'); delete hero.dataset.imgRule; classify(hero, 0); })
      .observe(hero, { attributes: true, attributeFilter: ['src'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
